<a
  [attr.download]="download"
  [attr.href]="href"
  [attr.hreflang]="hreflang"
  [attr.ping]="ping"
  [attr.rel]="rel"
  [attr.target]="target"
  [attr.type]="type"
>
  @if (icon) {
    <app-icon [name]="icon" class="icon"></app-icon>
  }
  <span><ng-content></ng-content></span
></a>
